// extracted by mini-css-extract-plugin
module.exports = {"status_container":"status_container--SquaredColorOption-Programs-components__2dt-F","statusContainer":"status_container--SquaredColorOption-Programs-components__2dt-F"};